'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import { AdWordsKeywordTypes } from 'AdsUI/lib/Constants';
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';

const KeywordMatchTypeSelect = ({
  value,
  onChange,
  onKeyUp,
  readOnly,
  showBroadOption = false
}) => {
  const onTypeChange = useCallback(e => onChange(e.target.value), [onChange]); // Memoized so that I18n.t isn't called before I18n is initialized

  const matchTypeOptions = useMemo(() => [{
    value: AdWordsKeywordTypes.EXACT,
    text: I18n.text('adwordsGlobal.matches.exact')
  }, {
    value: AdWordsKeywordTypes.PHRASE,
    text: I18n.text('adwordsGlobal.matches.phrase')
  }], []);

  const CustomItem = (_ref) => {
    let {
      children,
      option
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["children", "option"]);

    return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
      children: /*#__PURE__*/_jsx(UITooltip, {
        placement: "right",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "adwordsGlobal.matches.broadTooltip"
        }),
        disabled: !option.disabled,
        children: children
      })
    }));
  };

  const matchTypeOptionsWithBroadType = useMemo(() => [{
    value: AdWordsKeywordTypes.EXACT,
    text: I18n.text('adwordsGlobal.matches.exact')
  }, {
    value: AdWordsKeywordTypes.PHRASE,
    text: I18n.text('adwordsGlobal.matches.phrase')
  }, {
    value: AdWordsKeywordTypes.BROAD,
    text: I18n.text('adwordsGlobal.matches.broad'),
    disabled: true
  }], []);
  const options = showBroadOption ? matchTypeOptionsWithBroadType : matchTypeOptions;
  return /*#__PURE__*/_jsx(UISelect, {
    itemComponent: CustomItem,
    "data-test-id": "keyword-match-type-select",
    options: options,
    value: value,
    readOnly: readOnly,
    onChange: onTypeChange,
    onKeyUp: onKeyUp
  });
};

export default KeywordMatchTypeSelect;